import React from "react";
import { Link } from "react-router-dom";
import localapp from "./assets/image/Brand nfc.png";

const Footerbrand = () => {
  return (
    <div>
      <section className="pt-20 bg-gray">
        <div className="container">
          <div className="row">
            <div className="col-sm-12 col-md-6 px-2 text-center text-md-start align-self-center pb-20">
              <p className="mb-15 fw-semibold font-18">
                <Link to="/contact" className="text-decoration-none text-dark">
                  Create Smart Business Cards
                </Link>
              </p>
              <h2 className="fw-semibold text-dark pb-1">
                Connect With Your Customers Using <br /> 9|R NFC Cards and Build
                a <br />
                <span className="text-orange">Lifetime Relationship.</span>
              </h2>
              <p className="mb-8 mt-2 font-18">
                Grow your business with{" "}
                <span className="text-orange fw-400">9R NFC CARD</span>
              </p>
            </div>
            <div className="col-sm-12 col-md-6 align-self-end text-center">
              <img src={localapp} className="w-75 pb-3" alt="NFC Portfolio" />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Footerbrand;
